import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Typography } from '@quikr/ui';

import VIPTable from './VIPTable';

const Wrapper = styled.div`
  margin: -16px -16px 0 -16px;
  @media screen and (min-width: 768px) {
    margin: -24px -24px 0 -24px;
  }
`;

const PACK_TYPE = 'VIP2';

const VIPPack = ({ products, user, fireGa, getLinkRequest }) => {
  const [reqError, setreqError] = useState('');
  const getPrice = type => {
    return products.filter(option => option.type === type)[0].price;
  };
  const price = getPrice(PACK_TYPE);

  useEffect(() => {
    fireGa && fireGa('applyModal_paymentOptions_viewed');
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const formData = {
      user: {
        mobile: user.mobile,
        email: user.email
      },
      type: PACK_TYPE
    };
    if (user.id) {
      formData.user.id = parseInt(user.id);
    }
    const response = await getLinkRequest({
      variables: { payLoad: formData }
    });

    const data = response.data;
    if (data.getPaymentLink && data.getPaymentLink.paymentUrl) {
      fireGa && fireGa('applyModal_paymentOptions_buyNow');
      window.location.href = data.getPaymentLink.paymentUrl;
    } else {
      setreqError('Something went wrong! Please try again later');
    }
  };

  return (
    <Wrapper>
      {reqError && (
        <Typography className="form__error" tagName="p">
          {reqError}
        </Typography>
      )}
      <VIPTable price={price} handleSubmit={handleSubmit} />
    </Wrapper>
  );
};

VIPPack.propTypes = {
  user: PropTypes.object,
  products: PropTypes.array,
  fireGa: PropTypes.func,
  getLinkRequest: PropTypes.func
};

export default VIPPack;
